import type { LoginTranslations } from '../interfaces/login';

export const loginTranslations: LoginTranslations = {
  title:
    'Transforme suas ideias em Agentes de IA conversacionais para todos os seus canais',
  subtitle:
    'Comece pela plataforma líder (WhatsApp) e escale facilmente. A IA da {{brand}} cuida da automação de vendas e atendimento.',
  morningMessages: [],
  afternoonMessages: [],
  eveningMessages: [],
  footerMessages: [
    'Criamos o {{brand}} porque acreditamos que todos merecem construir algo grandioso sem limites. Pronto para começar?',
    'Não importa de onde você vem; o que importa é o que você cria. Com o {{brand}}, o mundo é a sua tela.',
    'Criamos o {{brand}} para que sua ideia ganhe vida em segundos. Comece hoje.',
    'Toda grande ideia começa com um primeiro passo. Hoje, esse passo é mais fácil do que nunca. Vamos construir o futuro juntos!',
    'Não existem limites quando você tem as ferramentas certas. E agora, você as tem.',
    'Um dia, sonhamos com isso e tornamos realidade. Hoje, damos a você o poder de fazer o mesmo.',
    'Começamos com uma ideia e um objetivo: provar que tudo é possível. Agora, é a sua vez.',
    'Acreditamos que podíamos fazer isso, e aqui estamos. Não duvide do que você pode criar.',
    'Não há truques, nem segredos — apenas acreditamos na nossa ideia e trabalhamos duro. Você também pode fazer isso.',
    'Se conseguimos construir isso do zero, o que te impede? Comece hoje.',
    'Não espere pelo momento perfeito. Nós não esperamos, apenas começamos. Agora, é a sua vez.',
    'Criamos o {{brand}} para provar que qualquer ideia pode se tornar realidade. A sua também.',
  ],
  google_button: 'Entre com o Google',
  login_button: 'Entrar',
  input_user_label: 'E-mail',
  input_user_placeholder: 'Digite seu e-mail',
  input_password_label: 'Senha',
  input_password_placeholder: 'Digite sua senha',
  checkbox_remember_me: 'Lembrar-me',
  login_account_label_prefix: 'Já tem uma conta?',
  login_account_label_button: 'Entrar',
  terms_and_conditions: 'Termos e condições',
  google_forbidden_title: 'Acesso restrito',
  google_forbidden_description: 'Esta conta não pode entrar neste painel.',
};
